<script>
  import { onMount } from 'svelte';
  import { fade } from 'svelte/transition';

  let {
    content,
    closeLabel,
    learnMoreLabel,
    yesLabel,
    noLabel,
    yesContent,
    noContent,
    questionContent,
    token,
    dataTestId = 'wizard',
  } = $props();

  // should show on page
  let show = $state(false);

  // state
  let view = $state('initial'); // yes or no or expand

  onMount(() => {
    if (localStorage.getItem(token) === null) {
      show = true;
    }
  });

  const onClose = () => {
    localStorage.setItem(token, true);
    show = false;
  };

  const expandWizard = () => {
    view = 'expand';
  };

  const handleYesClick = () => {
    view = 'yes';
  };

  const handleNoClick = () => {
    view = 'no';
  };
</script>

{#if show && content}
  <div
    transition:fade
    class="bg-blue-very-light lg:shadow-y-sm p-4 md:shadow-y-sm md:m-4 lg:mx-0"
    data-testid={dataTestId}
    data-token={token}
  >
    {#if view === 'expand'}
      <div in:fade>
        <div class="mb-4 text-sm items-center markdown-wrapper">
          {@html questionContent.content}
        </div>
        <div class="flex flex-row justify-around">
          <button
            class="text-sm lg:text-base font-bold text-blue-cerulean hover-hover:hover:text-blue-darkish active:text-blue-darkish hover-hover:hover:underline active:underline mr-4"
            onclick={handleYesClick}
          >
            {yesLabel}
          </button>
          <button
            class="text-sm lg:text-base font-bold text-blue-cerulean hover-hover:hover:text-blue-darkish active:text-blue-darkish hover-hover:hover:underline active:underline ml-4"
            onclick={handleNoClick}
          >
            {noLabel}
          </button>
        </div>
      </div>
    {:else if view === 'yes'}
      <div in:fade>
        <div class="mb-4 text-sm items-center markdown-wrapper">
          {@html yesContent.content}
        </div>
        <button
          class="text-sm font-bold text-blue-cerulean hover-hover:hover:text-blue-darkish active:text-blue-darkish hover-hover:hover:underline active:underline mr-4"
          onclick={onClose}
        >
          {closeLabel}
        </button>
      </div>
    {:else if view === 'no'}
      <div in:fade>
        <div class="mb-4 text-sm items-center markdown-wrapper">
          {@html noContent.content}
        </div>
        <button
          class="text-sm font-bold text-blue-cerulean hover-hover:hover:text-blue-darkish active:text-blue-darkish hover-hover:hover:underline active:underline mr-4"
          onclick={onClose}
        >
          {closeLabel}
        </button>
      </div>
    {:else}
      <div class="md:flex">
        <div class="text-sm items-center markdown-wrapper">
          {@html content}
        </div>
        <button
          class="text-sm font-bold text-blue-cerulean hover-hover:hover:text-blue-darkish active:text-blue-darkish hover-hover:hover:underline active:underline md:ml-2"
          onclick={expandWizard}
        >
          {learnMoreLabel}
        </button>
      </div>
    {/if}
  </div>
{/if}
